import PostcodeSection from '@/pages/Postcode';

export default function Landing() {
  return <PostcodeSection homepageMode />;
}
